export const approveMenus = [
    {
        title: '审批管理', key: 'approve_manage', icon: 'icon iconfont icon-hetongguanli-', compTypes: [9901, 9902, 9903], children: [
            { title: '设计奖补申请', key: '/approve/allowance', icon: 'icon iconfont icon-icon-test2' }
        ]
    },
];